module.exports = __webpack_public_path__ + "static/media/logo_white.9d13c40a.png";